import {useMemo} from 'react'

import {RoleConfiguration} from '../../../common/hooks/useRolesConfiguration'

type UseRoleConfigurationReturn = {
  roleDataScopeNames: Set<string>
  hasProjectSiteIdScopeInConfiguration: boolean
  hasContractIdScopeInConfiguration: boolean
}

export const useRoleConfiguration = (
  roleConfiguration?: RoleConfiguration
): UseRoleConfigurationReturn => {
  const roleDataScopeNames = useMemo((): Set<string> => {
    return roleConfiguration
      ? new Set(roleConfiguration.dataScopes.map((d) => d.dataScope))
      : new Set()
  }, [roleConfiguration])

  const hasProjectSiteIdScopeInConfiguration = useMemo((): boolean => {
    return ['siteIds', 'projectIds', 'siteId', 'projectId'].some((scope) =>
      roleDataScopeNames.has(scope)
    )
  }, [roleDataScopeNames])

  const hasContractIdScopeInConfiguration = useMemo((): boolean => {
    return roleDataScopeNames.has('contractIds')
  }, [roleDataScopeNames])

  return {
    roleDataScopeNames,
    hasProjectSiteIdScopeInConfiguration,
    hasContractIdScopeInConfiguration
  }
}
